import * as React from 'react';
import {Box, Grid} from '@material-ui/core';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Collapse from '@mui/material/Collapse';
import { useSpring, animated } from '@react-spring/web';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import CircularProgress from '@mui/material/CircularProgress';



function TransitionComponent(props) {
  const style = useSpring({
    from: {
      opacity: 0,
      transform: 'translate3d(20px,0,0)',
    },
    to: {
      opacity: props.in ? 1 : 0,
      transform: `translate3d(${props.in ? 0 : 20}px,0,0)`,
    },
  });

  return (
    <animated.div style={style}>
      <Collapse {...props} />
    </animated.div>
  );
}

TransitionComponent.propTypes = {
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
};


const useStyles = makeStyles({
  card: {
    marginBottom: 1,
  },
  cardBtn: {
    textTransform:'none !important',
    textAlign:'left !important',
    backgroundColor: 'transparent !important',
    fontSize: '12px !important',
    color:'#333333 !important',
  },
  cardHeading: {
    textTransform:'none !important',
    fontSize: '14px !important', 
    color: '#22436e !important', 
    fontWeight:'bold !important', 
    backgroundColor: 'transparent !important',
  },
  viewAllBtn: {
    textTransform:'none !important',
    textAlign:'left !important',
    backgroundColor: 'transparent !important',
    fontSize: '12px !important',
    color:'#333333 !important',
    marginRight:'-8px !important',
  },
});


export default function Execute(props) {
    const css = useStyles();

  function selectThisTopic(obj){
		props.selectTopic(obj);
	}

  return (
    <Box><Grid container spacing={2}>
    {(props.topicObj && props.topicObj.topicId>0 && props.topicObj.topicName && props.topicObj.topicName.length>0)?
    <>
        {/* If topic selected */}
        {props.topicObj.children.map((myObj,i)=>(
        <Grid item md={6} xs={12}>
          <Card key={'c'+i} className={css.card} style={{cursor:'pointer'}} onClick={()=>{selectThisTopic(myObj)}} >
          <CardContent>
            <Box style={{marginBottom:-18}}>
                      <Grid container spacing={1} >
                        <Grid item xs={1} >
                          <img src={(myObj.iconImage && myObj.iconImage.length>0 && myObj.iconImage!=='null')?myObj.iconImage:process.env.PUBLIC_URL+"/node.png"} style={{height:26}} />
                          {/* <i class="fa fa-solid fa-flask"></i> */}
                        </Grid>
                        <Grid item xs={11} style={{marginLeft:-4, marginTop: -4}} >
                          <Button className={css.cardBtn} onClick={()=>{selectThisTopic(myObj)}} >{myObj.topicName}</Button>
                        </Grid>
                      </Grid>
            </Box> 
          </CardContent>
          </Card>
        </Grid>
        ))}
    </>:(props.topicTree && props.topicTree.length>0)?<>
        {/* If topic not selected */}
        {props.topicTree.map((myObj,i)=>(
          <Grid item md={6} xs={12}>
          <Card key={'c'+i} className={css.card} style={{cursor:'pointer'}} onClick={()=>{selectThisTopic(myObj)}} >
          <CardContent>
            <Box style={{marginBottom:-18}}>
                      <Grid container spacing={1} >
                        <Grid item xs={1} >
                          <img src={(myObj.iconImage && myObj.iconImage.length>0 && myObj.iconImage!=='null')?myObj.iconImage:process.env.PUBLIC_URL+"/node.png"} style={{height:26}} />
                          {/* <i class="fa fa-solid fa-flask"></i> */}
                        </Grid>
                        <Grid item xs={11} style={{marginLeft:-4, marginTop: -4}} >
                          <Button className={css.cardBtn} onClick={()=>{selectThisTopic(myObj)}} >{myObj.topicName}</Button>
                        </Grid>
                      </Grid>
            </Box> 
          </CardContent>
          </Card>
          </Grid>
        ))}
    </>:
      <>
        <CircularProgress size={20} /> Loading...
      </>
    }  
    </Grid></Box>
  );
}


